import { loginByUsername, logout, getUserInfo } from '@/api/login'
import {
  getToken,
  setToken,
  removeToken,
  setEmpInfo,
  removeEmpInfo,
  setUserPermissions
} from '@/utils/auth'

const user = {
  state: {
    user: '',
    status: '',
    code: '',
    token: getToken(),
    name: '',
    avatar: '',
    introduction: '',
    roles: [],
    setting: {
      articlePlatform: []
    }
  },

  mutations: {
    SET_CODE: (state, code) => {
      state.code = code
    },
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_INTRODUCTION: (state, introduction) => {
      state.introduction = introduction
    },
    SET_SETTING: (state, setting) => {
      state.setting = setting
    },
    SET_STATUS: (state, status) => {
      state.status = status
    },
    SET_NAME: (state, name) => {
      state.name = name
    },
    SET_AVATAR: (state, avatar) => {
      state.avatar = avatar
    },
    SET_ROLES: (state, roles) => {
      state.roles = roles
    }
  },

  actions: {
    // 用户名登录
    LoginByUsername ({ commit }, userInfo) {
      const username = userInfo.username.trim()
      return new Promise((resolve, reject) => {
        loginByUsername(username, userInfo.password)
          .then(response => {
            const data = response.data
            console.log(data)
            commit('SET_TOKEN', data.token)
            setToken(response.data.token)
            /* if (data.data.isAdmin) {
              // 验证返回的roles是否是一个非空数组,如果设置了值，会造成导航栏不显示
              // commit('SET_ROLES', ['admin'])
            } else {
              commit('SET_TOKEN', '')
              commit('SET_ROLES', [])
              removeToken()
              console.log('登录--error')
              reject(new Error('getInfo: roles must be a non-null array !'))
            }*/
            commit('SET_NAME', data.title)
            commit('SET_AVATAR', '')
            commit('SET_INTRODUCTION', data.empName)
            setEmpInfo(JSON.stringify(data.data.empInfo))
            const permissionsData = data.data.permissions
            const userPermissionsMap = {}
            for (const key in permissionsData) {
              const item = permissionsData[key]
              userPermissionsMap[item.enName] = true
            }
            setUserPermissions(JSON.stringify(userPermissionsMap))
            console.log(userPermissionsMap)
            resolve()
          })
          .catch(error => {
            reject(error)
          })
      })
    },

    // 获取用户信息
    GetUserInfo ({ commit, state }) {
      return new Promise((resolve, reject) => {
        const data = {
          roles: ['admin']
        }
        commit('SET_ROLES', data.roles)
        const response = { data: data }
        resolve(response)
      })
    },

    // 登出
    LogOut ({ commit, state }) {
      return new Promise((resolve, reject) => {
        logout(state.token)
          .then(() => {
            commit('SET_TOKEN', '')
            commit('SET_ROLES', [])
            removeToken()
            removeEmpInfo()
            resolve()
          })
          .catch(error => {
            commit('SET_TOKEN', '')
            commit('SET_ROLES', [])
            removeToken()
            removeEmpInfo()
            reject(error)
          })
      })
    },

    // 前端 登出
    FedLogOut ({ commit }) {
      return new Promise(resolve => {
        commit('SET_TOKEN', '')
        removeToken()
        resolve()
      })
    },

    // 动态修改权限
    ChangeRoles ({ commit }, role) {
      return new Promise(resolve => {
        commit('SET_TOKEN', role)
        setToken(role)
        getUserInfo(role).then(response => {
          const data = response.data
          commit('SET_ROLES', data.roles)
          commit('SET_NAME', data.name)
          commit('SET_AVATAR', data.avatar)
          commit('SET_INTRODUCTION', data.introduction)
          resolve()
        })
      })
    }
  }
}

export default user
